(function($) {
	formHelper.addRule({
		form: '#form-update-account',
		status: {
			SUCCESS: function() {
				this.redirect(this.data.redirectTo);
			}
		}
	});
})(jQuery);

jQuery(function initToolsManageMyUserAccount($) {
	$('.update-account-form').each(function(index, el) {

		var $container             = $(this);
		var $form                  = $container.find('#form-update-account');
		var $submitBtn             = $container.find('.tools-button-row');

		$submitBtn.click(function() {
			$form.submit();
		});
	});
});